import { exact, arrayOf, bool, string, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/next';
import MessageBoxOld from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import ProductAttributes from 'yoda-checkout-components/lib/components/ProductAttributes/ProductAttributes';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export const OOSDiscontinuedMessage = ({
    outOfStockOrDiscontinuedItemPresent,
    notAvailableProducts,
    discontinuedOOSMessage: { TITLE, BODY },
    enableOOSDiscontinuedMessageWithItemHyperLink,
}) => {
    if (!outOfStockOrDiscontinuedItemPresent) {
        return null;
    }

    /* istanbul ignore next */
    const scrollToItem = (cartItemId) => {
        const match = document.getElementById(cartItemId);
        if (match && window) {
            const rect = match.getBoundingClientRect();
            const anchorOffset = window.pageYOffset + rect.top - 55;
            window.scrollTo(0, anchorOffset);
        }
    };

    const result = enableOOSDiscontinuedMessageWithItemHyperLink ? (
        <MessageBox
            messageType="info"
            automationId="at-discontinued-oos-detail-error"
            message={BODY}
            showMessage
            className={dt(['mb-6', 'mt-2', 'p-3'])}
            listProps={{
                automationId: 'at-discontinued-oos-msg-block',
                children: notAvailableProducts,
                listType: 'disc',
                // eslint-disable-next-line react/prop-types
                itemRenderer: ({ name, cartItemId, attributes }) => {
                    const productAttributes = attributes && (
                        <>
                            &nbsp;-&nbsp;{' '}
                            <ProductAttributes
                                attributes={attributes}
                                splitBy=" / "
                                className={dt([
                                    'text-black',
                                    'inline',
                                    'lg:text-base',
                                    'lg:!leading-6',
                                ])}
                                excludeVDataFormatting
                            />
                        </>
                    );

                    return (
                        <li className={dt(['mb-2', 'text-base', 'leading-6'])}>
                            <button
                                type="button"
                                onClick={/* istanbul ignore next */ () => scrollToItem(cartItemId)}
                                className={dt(['text-black', 'underline', 'text-left'])}
                            >
                                {name}
                                {productAttributes}
                            </button>
                        </li>
                    );
                },
            }}
        />
    ) : (
        <MessageBoxOld
            type="error"
            level="section"
            hasClose={false}
            className={dt(['mx-3', 'p-3'])}
            title={TITLE}
            automationId="at-discontinued-oos-detail-error"
        >
            <div data-automation-id="at-discontinued-oos-msg-block">{BODY}</div>
        </MessageBoxOld>
    );

    return result;
};

OOSDiscontinuedMessage.propTypes = {
    discontinuedOOSMessage: exact({
        BODY: string,
        TITLE: string,
    }),
    notAvailableProducts: arrayOf(object),
    outOfStockOrDiscontinuedItemPresent: bool,
    enableOOSDiscontinuedMessageWithItemHyperLink: bool,
};

OOSDiscontinuedMessage.defaultProps = {
    discontinuedOOSMessage: {
        BODY: '',
        TITLE: '',
    },
    notAvailableProducts: [],
    outOfStockOrDiscontinuedItemPresent: false,
    enableOOSDiscontinuedMessageWithItemHyperLink: true,
};

const mapStateToProps = (state) => {
    const {
        oosDetails: {
            discontinuedOOSDetails: {
                discontinuedItemProducts = [],
                discontinuedOOSMessage,
                oosItemProducts = [],
            } = { oosItemProducts: [], discontinuedItemProducts: [] },
            isShowModal: outOfStockOrDiscontinuedItemPresent,
        },
        context: {
            featureFlags: { enableOOSDiscontinuedMessageWithItemHyperLink = true },
        },
    } = state;

    return {
        discontinuedOOSMessage,
        notAvailableProducts: [...oosItemProducts, ...discontinuedItemProducts],
        outOfStockOrDiscontinuedItemPresent,
        enableOOSDiscontinuedMessageWithItemHyperLink,
    };
};

export default connect(mapStateToProps, null)(OOSDiscontinuedMessage);
